import React from "react";
import { StyledEngineProvider } from "@mui/styled-engine";
import AvistaApolloProvider from "./apollo";
import { MainContextProvider } from "./main-context";
import { MuiThemeProvider } from "./mui-theme-provider";

export const AvistaProvider: React.FC<React.PropsWithChildren> = ({ children }) => (
  <MainContextProvider>
    <StyledEngineProvider injectFirst>
      <MuiThemeProvider>
        <AvistaApolloProvider>{children}</AvistaApolloProvider>
      </MuiThemeProvider>
    </StyledEngineProvider>
  </MainContextProvider>
);
